(function() {
  "use strict";

  angular.module("NetworkUnknownProperties")

    .constant("NetworkUnknownPropertiesTabs", {
      SETUP: "setup",
      COMPUTERS: "computers"
    })

    .constant('UNKNOWN_NETWORK_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-computer',
        section: 'computers',
        caption: 'Computers',
        selected: false,
        show: true
      }
    ])

    .controller("NetworkUnknownPropertiesController", [
      "$scope", "$filter", "$location", "URLS", "NetworkListService", "toastr", "$routeParams",
      "URL_PARAMS", "TenantListService", "NetworkUnknownPropertiesTabs", "WorkstationListService",
      "SUPPORTED_OS", "WorkstationListPaging", "SORT_WORKSTATIONS", "NetworkListPaging",
      'EventHandlerService', 'UNKNOWN_NETWORK_PROPERTIES_TABS', '$rootScope',
      function(
        $scope, $filter, $location, URLS, NetworkListService, toastr, $routeParams,
        URL_PARAMS, TenantListService, NetworkUnknownPropertiesTabs, WorkstationListService,
        SUPPORTED_OS, WorkstationListPaging, SORT_WORKSTATIONS, NetworkListPaging,
        EventHandlerService, UNKNOWN_NETWORK_PROPERTIES_TABS, $rootScope) {



        $scope.tabs = UNKNOWN_NETWORK_PROPERTIES_TABS;
        $scope.networkUnknownPropertiesTabs = NetworkUnknownPropertiesTabs;
        $scope.searchPattern = "";
        $scope.searchInputFieldHolderFocusKey = "searchInputFieldHolderFocusKey";
        $scope.networkUnknown = null;
        $scope.networkUnknownOriginal = null;
        $scope.networkUnknownPropertiesForm = {};
        $scope.workstationListService = WorkstationListService;
        $scope.supportedOs = SUPPORTED_OS;
        $scope.helpCaption = "HelpGatewayPropertiesSetup";
        $scope.networkListService = NetworkListService;
        $scope.selectedNetwork = null;
        $scope.networkListPaging = new NetworkListPaging();

        //Computers **********************************************
        $scope.checkAllCheckboxes = false;
        $scope.lastPageReached = false;
        $scope.filtersList = null;
        $scope.workstationListPaging = new WorkstationListPaging();
        $scope.requestType = 'GET';
        $scope.workstationContainer = null;
        $scope.searchInputPlaceholderText = 'SearchComputerByName';
        $scope.noDataMessage = 'NoComputers';
        $scope.orderWorkstationsByText = "HostName";
        $scope.reverseWorkstations = false;
        $scope.eventHandlerService = EventHandlerService;

        (function(){
          initEventHandler();

          if ($routeParams['uknownNetworkSection']) {
            $scope.showSection = $routeParams['uknownNetworkSection'];
          } else {
            $scope.showSection = 'setup';
          }
        })();

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.setSection = function(section) {
          $scope.showSection = section;

          var url = $location.path();
          $location.path(url, false).search({ uknownNetworkSection: section });
        }

        $scope.$watch(function() {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
          }
        })


        $scope.networkSelectPopup = function (event) {
          event.stopPropagation();
          $scope.clearPopups();
          $scope.networkListPaging.pagingCriteria.pageSize = 5;
          $scope.networkListPaging.pagingCriteria.match = null;
          $scope.networkSelectConfiguration = {
            paginationObject: $scope.networkListPaging,
            placeholderText: 'Search',
            service: 'NetworkListService',
            contentHeight: 463,
          };
          $scope.networkSelectPopupObject = {
            dimensions: {height: 463, width: 400},
            offset: {top: 22, left: 60},
            pointerPosition: 'right',
            relativePosition: 'middle',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            context: 'selectNetwork',
            type: 'PAGINATION',
            title: 'SelectNetwork',
            confirmText: 'SelectNetwork',
            clickOutsideToClose: true
          }
        }

        $scope.clearPopups = function () {
          $scope.networkSelectConfiguration = null;
          $scope.networkSelectPopupObject = null;
        }

        $scope.$watch(function()  {
          return $scope.showSection;
        }, function() {
          if ($scope.showSection) {
            switch ($scope.showSection) {
              case NetworkUnknownPropertiesTabs.SETUP:
                $scope.helpCaption = "HelpGatewayPropertiesSetup";
                break;
              case NetworkUnknownPropertiesTabs.COMPUTERS:
                $scope.helpCaption = "HelpGatewayPropertiesComputer";
                break;
            }
          }
        }, true);

        //Computers

        $scope.$watch(function() {
          return $scope.networkUnknownOriginal;
        }, function()  {
          if ($scope.networkUnknownOriginal) {
            $scope.workstationListPaging.pagingCriteria.gateway = {
              gwIp: $scope.networkUnknownOriginal.gwIp,
              gwMac: $scope.networkUnknownOriginal.gwMac,
            };
            $scope.getWorkstationListPaged();
          }
        }, true)

        $scope.getWorkstationListPaged = function() {
          if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
            WorkstationListService.getWorkstationListPaged($scope.workstationListPaging).then(function(workstationContainer) {
              $scope.workstationContainer = workstationContainer;
            }).catch(function(error) {});
          } else {
            var watch = $scope.$watch(function() {
              return TenantListService.currentTenant;
            }, function() {
              if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
                watch();
                $scope.getWorkstationListPaged();
              }
            }, true);
          }
        };

        $scope.getNextPage = function functionName(showPrevious) {
          if (showPrevious) {
            if ($scope.workstationListPaging.pagingCriteria.page > 0) {
              $scope.workstationListPaging.pagingCriteria.page--;
            }
          } else {
            if ($scope.workstationListPaging.pagingCriteria.page + 1 < $scope.workstationContainer.page.totalPages) {
              $scope.workstationListPaging.pagingCriteria.page++;
            }
          }
          $scope.getWorkstationListPaged();
        }

        $scope.changeOrderByValue = function(textValue) {
          $scope.reverseWorkstations = !$scope.reverseWorkstations;
          if ($scope.reverseWorkstations) {
            $scope.workstationListPaging.pagingCriteria.direction = 'DESC';
          } else {
            $scope.workstationListPaging.pagingCriteria.direction = 'ASC';
          }
          $scope.workstationListPaging.pagingCriteria.sort = textValue;
          $scope.orderWorkstationsByText = SORT_WORKSTATIONS[textValue];
          $scope.getWorkstationListPaged();
        };


        $scope.editWorkstation = function(workstation) {
          if (workstation) {
            var url = URLS.WORKSTATION_PROPERTIES.replace(URL_PARAMS.WORKSTATION_ID.LOCATION, workstation.customProperties.id);
            $location.path(url);
          } else {
            throw "$scope.editSelectedUsers: workstation is missing";
          }
        };

        $scope.changeSelectedNetwork = function(network) {
          $scope.selectedNetwork = network;
        };

        $scope.saveChanges = function(form, $event) {
          if (form && $event) {
            if (form.$invalid) {
              $event.preventDefault();
            } else {
              if ($scope.selectedNetwork) {
                $scope.waitingForAnswer = true;
                var objectToSend = {
                  ip: $scope.networkUnknown.gwIp,
                  mac: $scope.networkUnknown.gwMac
                };
                $scope.selectedNetwork.addGateway(objectToSend, true).then(function(response) {
                  $scope.waitingForAnswer = false;
                  form.$setPristine();
                  toastr.success($filter("translate")("ChangesSaved"));
                  $location.path(URLS.NETWORK_LIST);
                }).catch(function() {
                  $scope.waitingForAnswer = false;
                });
              }
            }
          } else {
            throw "$scope.saveChanges: form or $event are missing";
          }
        };

        if ($routeParams[URL_PARAMS.NETWORK_UNKNOWN_ID.ROUTE]) {
          $scope.networkUnknownOriginal = JSON.parse($routeParams[URL_PARAMS.NETWORK_UNKNOWN_ID.ROUTE]);
          $scope.networkUnknown = angular.copy($scope.networkUnknownOriginal);
          if ($routeParams[URL_PARAMS.SHOW_NETWORK_UNKNOWN_SECTION.ROUTE]) {
            $scope.showSection = $routeParams[URL_PARAMS.SHOW_NETWORK_UNKNOWN_SECTION.ROUTE];
          } else {
            $scope.showSection = NetworkUnknownPropertiesTabs.SETUP;
          }
        }
      }
    ])
})();